import { amazonGetQuery, amazonPostQuery } from '../../api/orders/amazon';
import { setLoading } from '../index';
import { handleError } from 'services/ErrorService/ErrorService';
import { setOrders, selectOrder } from './OrdersSearchActions';
import { extractSelectedTicketIdFromState, getSimplrAccountIdOfSelectedTicket } from '../../extractFromState';
import { getSelectedOrder } from '../../selectors/tools';
import { wrapVariableInArrayIfNotArrayAlready } from '../../util';

const commonGetOrdersQuery = (query, endpoint, dispatch, isQuickAction = false) => {
  return amazonGetQuery(endpoint, query)
    .then((responseBody) => {
      dispatch(setLoading(false, 'searchPage'));
      const orders = wrapVariableInArrayIfNotArrayAlready(responseBody);
      dispatch(setOrders(orders));

      // select the fetched order data if called by the quick action button
      isQuickAction && dispatch(selectOrder(responseBody));
    })
    .catch((err) => {
      dispatch(setLoading(false, 'searchPage'));
      handleError({ error: err, customMessage: err.text || err.response?.text, showPopup: true });
      if (err.status === 404) {
        return dispatch(setOrders([]));
      }
    });
};

export const amazonGetOrderByNumber = (simplrAccountId, orderNumber, isQuickAction) => {
  return (dispatch) => {
    const query = { simplrAccountId, orderNumber };

    return commonGetOrdersQuery(query, '/getOrderByNumber', dispatch, isQuickAction);
  };
};

export const amazonGetOrdersByEmail = (simplrAccountId, email) => {
  return (dispatch) => {
    const query = { simplrAccountId, email };

    return commonGetOrdersQuery(query, '/getOrdersByEmail', dispatch);
  };
};

export const amazonGetCancelRefundAsurionOrderInformation = (amazonOrderNumber) => {
  return (dispatch, getState) => {
    const state = getState();

    const simplrAccountId = getSimplrAccountIdOfSelectedTicket(state);
    const orderNumber = amazonOrderNumber || getSelectedOrder(state)['AmazonOrderId'];
    const query = { simplrAccountId, orderNumber };

    return amazonGetQuery('/getCancelRefundAsurionOrderInformation', query);
  };
};

export const amazonCancelRefundAsurionOrderAutomatic = () => {
  return (dispatch, getState) => {
    const state = getState();

    const simplrAccountId = getSimplrAccountIdOfSelectedTicket(state);
    const orderNumber = getSelectedOrder(state)['AmazonOrderId'];
    const conversationId = extractSelectedTicketIdFromState(state);

    const body = { simplrAccountId, orderNumber, conversationId };

    return amazonPostQuery('/cancelRefundAsurionOrderAutomatic', body);
  };
};
